export default __webpack_public_path__ + "static/media/proposal_7.74b49ba9.png";